import type { ActionSource } from 'owa-timestream-store';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import createAssetsFromClipboardData from './createAssetsFromClipboardData';

export default function createAssetFromDescriptor(
    actionSource: ActionSource,
    assetDescriptor: AssetDescriptor,
    pageX: number,
    pageY: number,
    xOffset: number,
    yOffset: number
) {
    const { createAssets, createEmptyAsset } = assetDescriptor;

    const assetOrAssetsPromise = createAssets
        ? createAssets(pageX, pageY)
        : createEmptyAsset
        ? Promise.resolve(createEmptyAsset())
        : Promise.resolve(undefined);

    assetOrAssetsPromise.then(assetOrAssets => {
        createAssetsFromClipboardData(
            actionSource,
            assetOrAssets,
            pageX + xOffset,
            pageY + yOffset
        );
    });
}
